<template>
  <div class="sweet-table" :id="tableId">
    <el-table :ref="tableId" :id="'table_' + tableId" v-loading="dataListLoading" :data="dataList" border
              @selection-change="dataListSelectionChangeHandle" style="width: 100%" :highlight-current-row="true"
              :max-height="tableHeight" :row-key="rowKey" :show-summary="summariesColumn.length > 0"
              :summary-method="getSummaries" :cell-style="cellStyle" :stripe="true" empty-text="暂无数据"
              @row-click="rowClickHandle" @header-dragend="headerDragend" :row-style="rowStyle"
              @sort-change="sortChangeHandle">

      <el-table-column fixed="left" type="selection" header-align="center" align="center" width="60" v-if="selection"
                       :reserve-selection="true"></el-table-column>
      <el-table-column fixed="left" v-if="rowIndex" type="index" width="60" label="行号" header-align="center"
                       align="center"></el-table-column>
      <slot></slot>
    </el-table>
    <div class="page-box" v-if="isPage" style="justify-content: space-between">
      <div>
        <el-button type="text" @click="clearSelectionHandle" v-if="selection">清空选择</el-button>
      </div>
      <el-pagination :current-page="pageConfig.page" :page-sizes="[50, 100, 1000]" :page-size="pageConfig.limit"
                     :total="pageConfig.total" layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import BigNumber from 'bignumber.js'
import { getUUID } from '@/utils'
import XLSX from 'xlsx'
import moment from 'moment'

export default {
  name: 'SweetTable',
  props: {
    rowStyle: {
      type: Function | Object,
      default: () => {
      }
    },
    storageKey: {
      type: String,
      default: ''
    },
    apiVersion: {
      type: String,
      default: 'v1'
    },
    rowKey: {
      type: String,
      default: 'id'
    },
    selection: {
      type: Boolean,
      default: false
    },
    rowIndex: {
      type: Boolean,
      default: true
    },
    autoLoad: {
      type: Boolean,
      default: true
    },
    url: '',
    deleteUrl: '',
    isPage: {
      type: Boolean,
      default: true
    },
    queryForm: {
      type: Object,
      default: () => {
        return {}
      }
    },
    beforeTableBinding: {
      type: Function
    },
    afterTableBinding: {
      type: Function
    },
    summariesColumn: {
      type: Array,
      default: () => {
        return []
      }
    },
    height: {
      type: Number,
      default: undefined
    },
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    cellStyle: {
      type: Function | Object,
      default: () => {
        return {}
      }
    },
    pageSize: {
      type: Number,
      default: 50
    },
    beforeLoad: {
      type: Function,
      default: null
    },
    defaultQueryParams: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      tableHeight: undefined,
      tableId: '',
      dataListSelections: [],
      dataListLoading: false,
      dataList: [],
      pageConfig: {
        page: 1,
        limit: this.pageSize,
        total: 0
      },
      order: '',
      orderField: '',
    }
  },
  watch: {
    data: {
      handler: function (newVal) {
        if (newVal) {
          this.dataList = newVal
        }
      },
      immediate: true
    },
    height () {
      this.resize()
    }
  },
  computed: {
    tableEL () {
      return this.$refs[this.tableId]
    },
    tableConfigId () {
      if (this.storageKey) {
        return this.storageKey
      }
      return this.$route.fullPath
    }
  },
  mounted () {
    this.tableId = getUUID().replaceAll('-', '')
    this.$nextTick(() => {
      this.resize()
    })
  },
  methods: {
    doLayout(){
      console.log('doLayout')
      debugger
      this.$refs[this.tableId].doLayout()
    },
    setCurrentRow(row){
      this.$refs[this.tableId].setCurrentRow(row)
    },
    clearSelectionHandle () {
      this.$confirm('是否清空选择?').then(() => {
        this.$refs[this.tableId].clearSelection()
      })
    },
    sortChangeHandle (data) {
      if (!data.order || !data.prop) {
        this.order = ''
        this.orderField = ''
        return false
      }
      this.order = data.order.replace(/ending$/, '')
      this.orderField = data.prop.replace(/([A-Z])/g, '_$1').toLowerCase()
      this.reload()
    },
    headerDragend (newWidth, oldWidth, column, event) {
      let tableConfig = window.localStorage.getItem(this.tableConfigId)
      if (!tableConfig) {
        tableConfig = []
      } else {
        tableConfig = JSON.parse(tableConfig)
      }
      let oldData = tableConfig.find(tc => tc.property === column.property)
      if (oldData) {
        oldData.width = newWidth
      } else {
        tableConfig.push({
          property: column.property,
          width: newWidth
        })
      }
      window.localStorage.setItem(this.tableConfigId, JSON.stringify(tableConfig))
    },
    rowClickHandle (row) {
      this.$emit(`row-click`, row)
    },
    reset (form) {
      if (form) {
        form.resetFields()
      }
      this.reload()
    },
    async doDelete (row, labelName) {
      if (!labelName) {
        labelName = 'name'
      }
      if (!this.deleteUrl) {
        return
      }
      let tipLabel = '该记录'
      if (row[labelName]) {
        tipLabel = `【${row[labelName]}】`
      }
      let http=this.$api
      if(this.apiVersion === 'v2'){
        http=this.$api2
      }
      this.$confirm(`是否删除${tipLabel}?`, '操作提示').then(() => {
        http
            .delete(this.deleteUrl, {
              data: [row.id],
            })
            .then((res) => {
              this.reload()
              this.$message.success('删除成功')
            })
      })
    },

    async doBatchDelete (idKey, paramsHandler) {
      if (!idKey) {
        idKey = 'id'
      }
      let dataList = this.dataListSelections
      if (this.$c.isArrayEmpty(dataList)) {
        return this.$message.error('请选择要删除的数据')
      }
      let reqData = null
      if (paramsHandler) {
        reqData = paramsHandler(dataList)
      } else {
        let ids = dataList.map(item => item[idKey])
        if (this.$c.isArrayEmpty(ids)) {
          return
        }
        reqData = ids
      }
      this.$confirm(`是否删除【${dataList.length}】条记录?`, '操作提示').then(() => {
        this.$api
            .delete(this.deleteUrl, {
              data: reqData,
            })
            .then((res) => {
              this.reload()
              this.$message.success('删除成功')
            })
      })
    },
    getProperty (obj, str) {
      if (!str) {
        console.log(obj, str)
      }
      str = str.replace(/\[(\w+)\]/g, '.$1') // 处理数组下标
      let arr = str.split('.')
      for (let i in arr) {
        obj = obj[arr[i]] || ''
      }
      return obj
    },
    async export (fileName, afterLoaded) {
      let dataList = await this.fetchData(1, 2147483646, true)
      if (afterLoaded) {
        afterLoaded(dataList)
      }
      if(this.beforeTableBinding){
        try{
          this.beforeTableBinding(dataList)
        }catch (e){
          console.log(e)
        }
      }
      console.log('export',dataList)
      let columns = this.$refs[this.tableId].columns
      let header = columns.filter(c => c.property).map(r => r.label)
      let excelData = []
      excelData.push(header)
      dataList.forEach((row, index) => {
        let tmp = []
        columns.forEach((c) => {
          if (c.property === undefined) {
            return
          }
          tmp.push(this.getProperty(row, c.property))
        })
        excelData.push(tmp)
      })
      let workBook = XLSX.utils.book_new()
      let workSheet = await XLSX.utils.aoa_to_sheet(excelData)
      XLSX.utils.book_append_sheet(workBook, workSheet, 'sheet1')
      XLSX.writeFile(workBook, fileName + '_' + moment().format('yyyyMMDD') + '.xlsx')
    },
    resize () {
      console.log(1, this.height)
      if (this.height && this.height > 0) {
        this.tableHeight = this.height
        return
      }
      let tableEl = document.getElementById(this.tableId)
      if (!tableEl) {
        return
      }
      let parentDiv = tableEl.parentNode
      if (!parentDiv) {
        return
      }
      while (parentDiv.className != 'app-body' && parentDiv.parentNode) {
        parentDiv = parentDiv.parentNode
      }
      let bodyHeight = parentDiv.offsetHeight
      let pageBoxHeight = 0
      if (this.isPage) {
        let pageBox = tableEl.getElementsByClassName('page-box')
        if (pageBox && pageBox.length > 0) {
          pageBoxHeight = pageBox[0].offsetHeight
        }
      }
      let formHeight = 0
      let formEl = document.getElementsByClassName('query-form')
      if (formEl && formEl.length > 0) {
        formHeight = formEl[0].offsetHeight + 20
      }
      let tab = parentDiv.getElementsByClassName('el-tabs__header')
      console.log(parentDiv, tab)
      let tabHeight = 0
      if (tab && tab.length > 0) {
        tabHeight = tab[0].offsetHeight
      }
      this.tableHeight = bodyHeight - pageBoxHeight - formHeight - 40 - tabHeight
    },
    /**
     * 更新当前页
     */
    getDataList () {

      this.fetchData(this.isPage ? this.pageConfig.page : null, this.isPage ? this.pageConfig.limit : null)
    },
    /**
     * 从接口中获取数据
     * @param queryParams
     */
    async fetchData (page, pageSize, isExport) {
      if (!this.url) {
        return
      }
      let queryParams = {
        order: this.order,
        orderField: this.orderField,
        page: page,
        limit: pageSize,
        ...this.queryForm,
        ...this.defaultQueryParams,
      }
      if (this.beforeLoad) {
        if (!this.beforeLoad(queryParams)) {
          return
        }
      }
      this.dataListLoading = true
      try {
        let api_m = this.$api
        if (this.apiVersion === 'v2') {
          api_m = this.$api2
        }
        const res = await api_m.get(this.url, { params: queryParams })
        let dataList = res.list ? res.list : res
        if (dataList === null) {
          dataList = []
        }
        if (this.beforeTableBinding) {
          this.beforeTableBinding(dataList)
        }
        if (isExport) {
          return dataList
        } else {
          this.dataList = dataList
          this.pageConfig.total = this.isPage ? res.total : 0
          this.$nextTick(() => {
            if (this.afterTableBinding) {
              this.afterTableBinding(dataList)
            }
          })
        }
      } catch (e) {
        this.dataList = []
        this.pageConfig.total = 0
      }
      this.dataListLoading = false
    },
    reload () {
      this.dataListSelections = []
      this.clearSelection()
      this.pageConfig.page = 1
      this.getDataList()
    },
    //清空选择
    clearSelection () {
      this.$refs[this.tableId].clearSelection()
    },
    //合计
    getSummaries (param) {
      if (!this.summariesColumn || this.summariesColumn.length === 0) {
        return
      }
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
          return
        }
        if (this.summariesColumn.indexOf(column.property) === -1) {
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            let value = Number(curr)
            if (!isNaN(value)) {
              return new BigNumber(prev).plus(curr).toFixed(2)
            } else {
              return prev
            }
          }, 0)
        }
      })
      return sums
    },
    // 多选
    dataListSelectionChangeHandle (val) {
      this.dataListSelections = val
      this.$emit('selection-change', val)
    },
    // 排序
    dataListSortChangeHandle (data) {
      if (!data.order || !data.prop) {
        this.order = ''
        this.orderField = ''
        return false
      }
      this.order = data.order.replace(/ending$/, '')
      this.orderField = data.prop.replace(/([A-Z])/g, '_$1').toLowerCase()
      this.reload()
    },
    // 分页, 每页条数
    pageSizeChangeHandle (val) {
      this.pageConfig.limit = val
      this.reload()
    },
    // 分页, 当前页
    pageCurrentChangeHandle (val) {
      this.pageConfig.page = val
      this.getDataList()
    },
  }
}
</script>

<style lang="scss" scoped>
.sweet-table {
  padding: 10px 0 0 0;
}

.page-box {
  display: flex;
  padding: 10px 0;
  justify-content: flex-end;
  width: 100%;
}
</style>
